import api from '@/utils/api';

/**
 * get user
 *
 * @param {string} userId - The user get
 * @returns {Promise} The promise object of the api call
 */
const getUserApi = (userId) => api.get(`user/${userId}`);
export default getUserApi;
